import axios from "axios";
import AuthService from "./auth.services";

const API_URL = "/api/v1/get-all-logs";

const getAccessToken = () => AuthService.getCurrentUser()?.accessToken || null;

const apiLogService = () => {
    const accessToken = getAccessToken();
    if (!accessToken) return Promise.reject(new Error("Authentication required."));

    return axios.get(API_URL, {
        headers: {
            Authorization: 'Bearer ' + accessToken,
        }
    },);
};


const ApiLogService = {
    apiLogService
}

export default ApiLogService;